import axios from "axios";
import config from "./config";

export const oauthTokenFromCognito = (body) => {
  return axios.post("/oauth/token-from-cognito", body, config);
}